export default "__VITE_ASSET__BSrjKDig__"